import { Keuzehulp } from "../keuzehulpen";

const hersenAneurysma: Keuzehulp = {
  title: 'Hersen-aneurysma',
  basePath: '/hersen-aneurysma',
  documentTitle: 'Hersen-aneurysma',
  routes: [
    {
      path: '',
      routeId: 'P17-001',
      nextRouteId: 'P17-002',
      type: 'intro',
      title: 'Voordat je begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/ik-heb-hersen-aneurysma-welke-keuzes-heb-ik',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die je nodig hebt om de keuzehulp in te vullen.',
        },
        {
          title: '15-20 minuten',
          description: 'Zo lang doen de meeste mensen over deze keuzehulp.',
        },
        {
          title: 'Zoek een rustige plek',
          description: 'Zodat je goed je aandacht erbij kunt houden.',
        },
        {
          title: 'Bekijk je antwoorden',
          description:
            'Je antwoorden worden niet bewaard. De keuzehulp onthoudt niet waar je gebleven bent.',
        },
      ],
    },
    {
      path: '/stap-1',
      routeIndex: '1',
      routeId: 'P17-002',
      nextRouteId: 'P17-003',
      type: 'chapter',
      title: 'Een hersen-aneurysma',
      subtitle: 'Stap 1',
      description: `
        <p>In deze stap leggen we uit wat een hersen-aneurysma precies is.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/ha-stap-1.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/wat-is-een-hersen-aneurysma',
      routeId: 'P17-003',
      nextRouteId: 'P17-004',
      type: 'explanation',
      title: 'Wat is een hersen-aneurysma?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Een hersen-aneurysma is een zwakke plek aan de zijkant van een bloedvat in de hersenen. Het ziet eruit als een ballonnetje aan een bloedvat. Heel soms wordt de zijkant van het bloedvat steeds zwakker en wordt het aneurysma groter. Uiteindelijk kan het aneurysma knappen. Je krijgt dan een bloeding tussen je hersenen en je schedel.</p>

          <p>Bij de meeste mensen groeit of knapt het aneurysma niet. Gezond leven, niet roken en een normale bloeddruk maken de kans kleiner dat het aneurysma groeit of knapt.</p>

          <p>Of het aneurysma knapt hangt af van verschillende dingen. Bijvoorbeeld deze dingen:</p>
          <ul>
            <li>hoe groot het aneurysma is</li>
            <li>waar het aneurysma precies zit</li>
          </ul>

          <p>Je arts bespreekt met je hoe groot de kans is dat het aneurysma bij jou knapt.</p>

          <p>Meestal merk je niet dat je een aneurysma hebt. Je kunt ook niet voelen aankomen of je aneurysma gaat knappen.</p>

          <div class="img-wrapper">
            <img src="${process.env.PUBLIC_URL}/img/ha-stap-1_1.webp" alt="">
          </div>
          <p>Een hersen-aneurysma ziet eruit als een ballonnetje aan een bloedvat in je hersenen.</p>

        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/welke-mogelijkheden-zijn-er-bij-een-hersen-aneurysma',
      routeId: 'P17-004',
      nextRouteId: 'P17-005',
      type: 'explanation',
      title: 'Welke mogelijkheden zijn er bij een hersen-aneurysma?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Er zijn verschillende mogelijkheden bij een hersen-aneurysma. Je kunt kiezen uit deze mogelijkheden:</p>

          <ul>
            <li><b>afwachten en geen scan maken</b></li>
            <br />
            <li><b>controleren met een scan</b><br /> Je arts maakt een scan van de bloedvaten in je hoofd om te kijken of je hersen-aneurysma is gegroeid.</li>
            <br />
            <li><b>een behandeling via je lies</b><br /> Via een slangetje in je lies, tussen je buik en je bovenbeen, schuift je arts metalen draadjes in je hersen-aneurysma. Je arts kan ook een dun buisje of ballonnetje van gaas gebruiken. Zo komt er geen bloed meer in je aneurysma en kan je aneurysma niet meer knappen.</li>
            <br />
            <li><b>een behandeling via je schedel</b><br /> Via een luikje in je schedel zet je arts een klemmetje tussen je bloedvat en je aneurysma. Zo komt er geen bloed meer in je aneurysma en kan je aneurysma niet meer knappen.</li>
          </ul>

        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/wat-is-belangrijk-bij-je-keuze',
      routeId: 'P17-005',
      nextRouteId: 'P17-006',
      type: 'explanation',
      title: 'Wat is belangrijk bij je keuze?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Er zijn verschillende mogelijkheden, maar soms kun je niet uit alle mogelijkheden kiezen. De keuze hangt af van jouw persoonlijke situatie. Daarbij zijn deze dingen belangrijk:</p>

          <ul>
            <li>waar je aneurysma precies zit</li>
            <li>hoe groot je aneurysma is</li>
            <li>hoe je aneurysma eruitziet</li>
            <li>hoe groot de kans is dat je aneurysma knapt</li>
            <li>je leeftijd</li>
            <li>de risico's van een behandeling voor jou</li>
            <li>of je gezond bent en een behandeling aankunt</li>
            <li>wat jij belangrijk vindt</li>
          </ul>

          <p>Samen met je arts bespreek je welke keuze het beste bij jou past. Bij de meeste mensen is de kans dat hun aneurysma knapt kleiner dan de kans dat er bij een behandeling iets misgaat.</p>

        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/vraag-1',
      routeId: 'P17-006',
      nextRouteId: 'P17-007',
      type: 'question',
      hideFromOverview: true,
      title: 'Waar wil je meer over weten?',
      description:
        'Vink aan waarover jij meer wilt weten. Vink alle opties aan als je over elke keuze meer wilt weten.',
      descriptionAlign: 'left',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'afwachten en geen scan maken',
              showChapter: '2',
            },
            {
              title: 'controleren met een scan',
              showChapter: '3',
            },
            {
              title: 'een behandeling via je lies',
              showChapter: '4',
            },
            {
              title: 'een behandeling via je schedel',
              showChapter: '5',
            },

          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2',
      routeIndex: '2',
      routeId: 'P17-007',
      nextRouteId: 'P17-008',
      type: 'chapter',
      title: 'Afwachten en geen scan maken',
      subtitle: 'Stap 2',
      description: `
        <p>In deze stap leggen we uit wat het betekent als je kiest voor afwachten en geen scan maken.</p>`,
      image: {
        src:  `${process.env.PUBLIC_URL}/img/ha-stap-2.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/wat-betekent-afwachten',
      routeId: 'P17-008',
      nextRouteId: 'P17-009',
      type: 'explanation',
      title: 'Wat betekent afwachten en geen scan maken?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je kunt ervoor kiezen om af te wachten en geen scan te laten maken. Je weet dan niet of je hersen-aneurysma groeit of niet.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/wat-zijn-de-voordelen-van-afwachten',
      routeId: 'P17-009',
      nextRouteId: 'P17-010',
      type: 'explanation',
      title: 'Wat zijn de voordelen van afwachten en geen scan maken?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Dit zijn de voordelen van afwachten en geen scan maken:</p>

          <ul>
            <li>Omdat je geen behandeling krijgt, heb je ook geen risico's van een behandeling.</li>
            <li>Je hoeft niet naar het ziekenhuis voor afspraken.</li>
            <li>Je hebt geen last van stress of spanning voor het resultaat van een controle-scan.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/wat-zijn-de-nadelen-van-afwachten',
      routeId: 'P17-010',
      nextRouteId: 'P17-011',
      type: 'explanation',
      title: 'Wat zijn de nadelen van afwachten en geen scan maken?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Dit zijn de nadelen van afwachten en geen scan maken:</p>

          <ul>
            <li>Je weet niet of je aneurysma groeit of niet.</li>
            <li>Je kunt onrustig of onzeker zijn omdat je weet dat je een aneurysma in je hoofd hebt.</li>
            <li>Je aneurysma wordt niet behandeld. Er is een kans dat je aneurysma knapt en je een bloeding krijgt.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-1',
      routeId: 'P17-011',
      nextRouteId: 'P17-012',
      type: 'question',
      title: 'Wat zijn voor jou de voordelen en nadelen van afwachten en geen scan maken?',
      questions: [
        {
          placeholder:
            'Vul hier je antwoord in.',
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-3',
      routeIndex: '3',
      routeId: 'P17-012',
      nextRouteId: 'P17-013',
      type: 'chapter',
      title: 'Controleren met een scan',
      subtitle: 'Stap 3',
      description: `
        <p>In deze stap leggen we uit hoe controleren met een scan gaat.</p>`,
      image: {
        src:  `${process.env.PUBLIC_URL}/img/ha-stap-3.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/hoe-gaat-controleren-met-een-scan',
      routeId: 'P17-013',
      nextRouteId: 'P17-014',
      type: 'explanation',
      title: 'Hoe gaat controleren met een scan?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je komt de eerste paar jaar regelmatig voor een controle-afspraak bij je arts. Je arts maakt een scan van je hoofd om te kijken of je aneurysma is gegroeid. Meestal kom je ongeveer 1 keer per jaar voor een controle-afspraak. Het kan ook vaker of minder vaak zijn.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Is je aneurysma gegroeid?</h2>
          <p style="margin-top: 0;">Dan bespreek je met je arts of je een behandeling wilt en wat de risico's daarbij zijn.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Is je aneurysma niet gegroeid?</h2>
          <p style="margin-top: 0;">Dan kun je weer een volgende controle-afspraak met je arts maken. Of je kunt toch kiezen voor een behandeling. Bespreek met je arts wat voor jou belangrijk is.</p>

          <p>Als je aneurysma in de eerste jaren niet is gegroeid, kun je samen met je arts besluiten om minder vaak te controleren. Bijvoorbeeld elke 2 of 5 jaar. </p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/wat-zijn-de-voordelen-van-controleren-met-een-scan',
      routeId: 'P17-014',
      nextRouteId: 'P17-015',
      type: 'explanation',
      title: 'Wat zijn de voordelen van controleren met een scan?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Dit zijn de voordelen van controleren met een scan:</p>

          <ul>
            <li>Omdat je geen behandeling krijgt, heb je ook geen risico's van een behandeling.</li>
            <li>Je weet of je aneurysma groeit of niet.</li>
            <li>Als je aneurysma is gegroeid, kun je altijd nog voor een behandeling kiezen.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/wat-zijn-de-nadelen-van-controleren-met-een-scan',
      routeId: 'P17-015',
      nextRouteId: 'P17-016',
      type: 'explanation',
      title: 'Wat zijn de nadelen van controleren met een scan?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Dit zijn de nadelen van controleren met een scan:</p>

          <ul>
            <li>Je moet naar het ziekenhuis voor de scan en voor de controle-afspraak.</li>
            <li>Je kunt stress hebben omdat je te horen krijgt of je aneurysma wel of niet is gegroeid.</li>
            <li>Je aneurysma wordt niet behandeld. Er is altijd een kans dat je aneurysma knapt en je een bloeding krijgt.</li>
            <li>Je kunt onrustig of onzeker zijn omdat je weet dat je een aneurysma in je hoofd hebt.</li>
          </ul>

          <p>Als je arts op de scan ziet dat je aneurysma is gegroeid, kun je soms snel een behandeling nodig hebben. Je kunt hiervan schrikken.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-1',
      routeId: 'P17-016',
      nextRouteId: 'P17-017',
      type: 'question',
      title: 'Wat zijn voor jou de voordelen en nadelen van controleren met een scan?',
      questions: [
        {
          placeholder:
            'Vul hier je antwoord in.',
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4',
      routeIndex: '4',
      routeId: 'P17-017',
      nextRouteId: 'P17-018',
      type: 'chapter',
      title: 'Een behandeling via je lies',
      subtitle: 'Stap 4',
      description: `
        <p>In deze stap leggen we uit hoe een behandeling via je lies gaat.</p>`,
      image: {
        src:  `${process.env.PUBLIC_URL}/img/ha-stap-4.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/hoe-gaat-een-behandeling-via-je-lies',
      routeId: 'P17-018',
      nextRouteId: 'P17-019',
      type: 'explanation',
      title: 'Hoe gaat een behandeling via je lies?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je wordt eerst met medicijnen in slaap gebracht. Dit heet narcose. Je merkt dan niets van de behandeling. In de video hieronder zie je hoe de behandeling gaat.</p>
        </div>
      `,
      videos: [
        {
          title: 'Video: een behandeling via je lies',
          src: 'https://media.thuisarts.nl/hersenaneurysma-via-lies-thuisarts.mp4',
          soundSrc: 'https://media.thuisarts.nl/hersenaneurysma-via-lies-thuisarts.mp3',
          poster: 'https://media.thuisarts.nl/hersenaneurysma-via-lies-thuisarts.jpg',
          videoSize: '77mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/hersenaneurysma-via-lies-thuisarts.vtt',
              subtitleSize: '1kb',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/wat-zijn-de-voordelen-van-een-behandeling-via-je-lies',
      routeId: 'P17-019',
      nextRouteId: 'P17-020',
      type: 'explanation',
      title: 'Wat zijn de voordelen van een behandeling via je lies?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Dit zijn de voordelen van een behandeling via je lies:</p>

          <ul>
            <li>Je aneurysma kan na de behandeling niet meer knappen.</li>
            <li>Sommige mensen vinden een behandeling via de lies minder spannend dan een behandeling via de schedel.</li>
            <li>Je arts kan soms op plekken komen waar die niet bij kan met een behandeling via je schedel.</li>
            <li>Je arts hoeft geen haar op je hoofd weg te scheren. Dit moet meestal wel bij een behandeling via je schedel.</li>
            <li>Je krijgt geen litteken op je hoofd.</li>
            <li>Je krijgt geen deukje in je schedel.</li>
          </ul>
        </div>
      `,

      button: 'Ga verder',
    },
    {
      path: '/stap-4/wat-zijn-de-nadelen-van-een-behandeling-via-je-lies',
      routeId: 'P17-020',
      nextRouteId: 'P17-021',
      type: 'explanation',
      title: 'Wat zijn de nadelen van een behandeling via je lies?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Dit zijn de nadelen van een behandeling via je lies:</p>

          <ul>
            <li>Soms lukt het niet om je aneurysma goed op te vullen. In dat geval heb je soms een extra behandeling nodig.</li>
            <li>Soms houden de draadjes, het buisje of het ballonnetje na een tijd het bloed niet goed meer tegen. Er kan dan weer wat bloed in je aneurysma komen.</li>
          </ul>

          <p>Om dit te controleren, kom je 6 maanden na je behandeling terug bij je arts. Je krijgt dan een scan van de bloedvaten in je hoofd. Zo kijkt je arts of er geen bloed in je aneurysma stroomt. Als er wel weer bloed in je aneurysma komt, dan heb je soms een extra behandeling nodig.</p>

          <p>Sommige mensen hebben na de behandeling last van moe zijn. Of ze kunnen zich minder goed concentreren. Dit gaat soms niet meer weg. Je kunt wel leren om hier zo goed mogelijk mee om te gaan.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Risico's</h2>
          <p style="margin: 0;">De behandeling heeft risico's. Zoals:</p>
          <ul style="margin-top: 0;">
            <li>een bloeding in je lies</li>
            <li>een bloeding in je hoofd</li>
            <li>een afsluiting van een bloedvat in je hoofd (herseninfarct)</li>
          </ul>

          <p>De kans op deze problemen is klein en voor iedereen anders. Het hangt ook af van wat je arts gebruikt om je aneurysma op te vullen: metalen draadjes, een dun buisje of een ballonnetje van gaas. Je arts bespreekt met je hoe groot de kans op risico's bij jou is.</p>

        </div>
      `,

      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-1',
      routeId: 'P17-021',
      nextRouteId: 'P17-022',
      type: 'question',
      title: 'Wat zijn voor jou de voordelen en nadelen van een behandeling via je lies?',
      questions: [
        {
          placeholder:
            'Vul hier je antwoord in.',
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-5',
      routeIndex: '5',
      routeId: 'P17-022',
      nextRouteId: 'P17-023',
      type: 'chapter',
      title: 'Een behandeling via je schedel',
      subtitle: 'Stap 5',
      description: `
        <p>In deze stap leggen we uit hoe een behandeling via je schedel gaat.</p>`,
      image: {
        src:  `${process.env.PUBLIC_URL}/img/ha-stap-5.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-5/hoe-gaat-een-behandeling-via-je-schedel',
      routeId: 'P17-023',
      nextRouteId: 'P17-024',
      type: 'explanation',
      title: 'Hoe gaat een behandeling via je schedel?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je wordt eerst met medicijnen in slaap gebracht. Dit heet narcose. Je merkt dan niets van de behandeling. In de video hieronder zie je hoe de behandeling gaat.</p>
        </div>
      `,
      videos: [
        {
          title: 'Video: een behandeling via je schedel',
          src: 'https://media.thuisarts.nl/hersenaneurysma-via-schedel-thuisarts.mp4',
          soundSrc: 'https://media.thuisarts.nl/hersenaneurysma-via-schedel-thuisarts.mp3',
          poster: 'https://media.thuisarts.nl/hersenaneurysma-via-schedel-thuisarts.jpg',
          videoSize: '18mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/hersenaneurysma-via-schedel-thuisarts.vtt',
              subtitleSize: '1kb',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-5/wat-zijn-de-voordelen-van-een-behandeling-via-je-schedel',
      routeId: 'P17-024',
      nextRouteId: 'P17-025',
      type: 'explanation',
      title: 'Wat zijn de voordelen van een behandeling via je schedel?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Dit zijn de voordelen van een behandeling via je schedel:</p>

          <ul>
            <li>Je aneurysma kan na de behandeling niet meer knappen.</li>
            <li>De kans dat er weer bloed in je aneurysma komt is heel klein.</li>
            <li>Na de behandeling hoef je nog maar 1 keer voor controle terug te komen bij je arts.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-5/wat-zijn-de-nadelen-van-een-behandeling-via-je-schedel',
      routeId: 'P17-025',
      nextRouteId: 'P17-026',
      type: 'explanation',
      title: 'Wat zijn de nadelen van een behandeling via je schedel?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Dit zijn de nadelen van een behandeling via je schedel:</p>

          <ul>
            <li>Meestal moet je arts een beetje haar op je hoofd wegscheren.</li>
            <li>Je krijgt een litteken op je hoofd.</li>
            <li>Je kunt een deukje in je schedel krijgen.</li>
          </ul>

          <p>Sommige mensen hebben na de behandeling last van moe zijn. Of ze kunnen zich minder goed concentreren. Dit gaat soms niet meer weg. Je kunt wel leren om hier zo goed mogelijk mee om te gaan.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Risico's</h2>
          <p style="margin: 0;">De behandeling heeft risico's. Zoals:</p>
          <ul style="margin-top: 0;">
            <li>een bloeding in je hoofd</li>
            <li>een afsluiting van een bloedvat in je hoofd (herseninfarct)</li>
            <li>dikker worden van de hersenen (hersenzwelling)</li>
          </ul>

          <p>De kans op deze problemen is klein en voor iedereen anders. Je arts bespreekt met je hoe groot de kans op risico's bij jou is.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-5/vraag-1',
      routeId: 'P17-026',
      nextRouteId: 'P17-027',
      type: 'question',
      title: 'Wat zijn voor jou de voordelen en nadelen van een behandeling via je schedel?',
      questions: [
        {
          placeholder:
            'Vul hier je antwoord in.',
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-6',
      routeIndex: '6',
      routeId: 'P17-027',
      nextRouteId: 'P17-028',
      type: 'chapter',
      title: 'Overzicht',
      subtitle: 'Stap 6',
      description: `
        <p>In deze stap zetten we de belangrijkste voordelen en nadelen van elke keuze op een rij.</p>`,
      image: {
        src:  `${process.env.PUBLIC_URL}/img/ha-stap-6.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-6/voordelen-en-nadelen',
      routeId: 'P17-028',
      nextRouteId: 'P17-029',
      type: 'explanation',
      title: '',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <table class="table-layout-fixed">
            <thead>
              <tr>
                <th></th>
                <th>Voordelen</th>
                <th>Nadelen</th>

              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Afwachten en geen scan maken</th>
                <td>
                  <ul>
                    <li>Omdat je geen behandeling krijgt, heb je ook geen risico's van een behandeling.</li>
                    <li>Je hoeft niet naar het ziekenhuis voor afspraken.</li>
                    <li>Je hebt geen last van stress of spanning voor het resultaat van een controle-scan.</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>Je weet niet of je aneurysma groeit of niet.</li>
                    <li>Je kunt onrustig of onzeker zijn omdat je weet dat je een aneurysma in je hoofd hebt.</li>
                    <li>Je aneurysma wordt niet behandeld. Er is een kans dat je aneurysma knapt en je een bloeding krijgt.</li>
                  </ul>
                </td>

              </tr>
              <tr>
                <th>Controleren met een scan</th>
                <td>
                  <ul>
                    <li>Omdat je geen behandeling krijgt, heb je ook geen risico's van een behandeling.</li>
                    <li>Je weet of je aneurysma groeit of niet.</li>
                    <li>Als je aneurysma is gegroeid, kun je altijd nog voor een behandeling kiezen.</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>Je moet naar het ziekenhuis voor de scan en voor de controle-afspraak.</li>
                    <li>Je kunt stress hebben omdat je te horen krijgt of je aneurysma wel of niet is gegroeid.</li>
                    <li>Je aneurysma wordt niet behandeld. Er is altijd een kans dat je aneurysma knapt en je een bloeding krijgt.</li>
                    <li>Je kunt onrustig of onzeker zijn omdat je weet dat je een aneurysma in je hoofd hebt.</li>
                    <li>Als je arts op de scan ziet dat je aneurysma is gegroeid, kun je soms snel een behandeling nodig hebben. Je kunt hiervan schrikken.</li>
                  </ul>
                </td>
              </tr>

              <tr>
                <th>Een behandeling via je lies</th>
                <td>
                  <ul>
                    <li>Je aneurysma kan na de behandeling niet meer knappen.</li>
                    <li>Sommige mensen vinden een behandeling via de lies minder spannend dan een behandeling via de schedel.</li>
                    <li>Je arts kan soms op plekken komen waar die niet bij kan met een behandeling via je schedel.</li>
                    <li>Je arts hoeft geen haar op je hoofd weg te scheren. Dit moet meestal wel bij een behandeling via je schedel.</li>
                    <li>Je krijgt geen litteken op je hoofd.</li>
                    <li>Je krijg geen deukje in je schedel.</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>Soms lukt het niet om je aneurysma goed op te vullen. In dat geval heb je soms een extra behandeling nodig.</li>
                    <li>Soms houden de draadjes, het buisje of het ballonnetje na een tijd het bloed niet goed meer tegen. Er kan dan weer wat bloed in je aneurysma komen. Je hebt dan soms een extra behandeling nodig.</li>
                    <li>Sommige mensen hebben na de behandeling last van moe zijn. Of ze kunnen zich minder goed concentreren. Dit gaat soms niet meer weg. Je kunt wel leren om hier zo goed mogelijk mee om te gaan.</li>
                  </ul>
                </td>
              </tr>

              <tr>
                <th>Een behandeling via je schedel</th>
                <td>
                  <ul>
                    <li>Je aneurysma kan na de behandeling niet meer knappen.</li>
                    <li>De kans dat er weer bloed in je aneurysma komt is heel klein.</li>
                    <li>Na de behandeling hoef je nog maar 1 keer voor controle terug te komen bij je arts.</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>Meestal moet je arts een beetje haar op je hoofd wegscheren.</li>
                    <li>Je krijgt een litteken op je hoofd.</li>
                    <li>Je kunt een deukje in je schedel krijgen.</li>
                    <li>Sommige mensen hebben na de behandeling last van moe zijn. Of ze kunnen zich minder goed concentreren. Dit gaat soms niet meer weg. Je kunt wel leren om hier zo goed mogelijk mee om te gaan.</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-7',
      routeIndex: '7',
      routeId: 'P17-029',
      nextRouteId: 'P17-030',
      type: 'chapter',
      title: 'Wat vind jij belangrijk?',
      subtitle: 'Stap 7',
      description: `
        <p>Je krijgt nu een paar vragen of stellingen te zien. Door hier antwoord op te geven, ontdek je wat voor jou belangrijk is.</p>`,
      image: {
        src:  `${process.env.PUBLIC_URL}/img/ha-stap-7.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-7/vraag-1',
      routeId: 'P17-030',
      nextRouteId: 'P17-031',
      type: 'likertScale',
      subtitle: 'Stelling',
      title:
        'Ik maak me zorgen dat mijn hersen-aneurysma knapt',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/vraag-2',
      routeId: 'P17-031',
      nextRouteId: 'P17-032',
      type: 'likertScale',
      subtitle: 'Stelling',
      title:
        'Ik wil geen behandeling via mijn lies of schedel als de kans maar heel klein is dat mijn hersen-aneurysma knapt',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/vraag-3',
      routeId: 'P17-032',
      nextRouteId: 'P17-033',
      subtitle: 'Stelling',
      title: 'Ik ben bang voor een behandeling via mijn lies of mijn schedel',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ja' },
        { title: 'Nee' },
        { title: 'Weet ik niet' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/vraag-4',
      routeId: 'P17-033',
      nextRouteId: 'P17-034',
      subtitle: 'Stelling',
      title: 'Een regelmatige controle van mijn hersen-aneurysma geeft mij genoeg rust',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ja' },
        { title: 'Nee' },
        { title: 'Weet ik niet' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/vraag-5',
      routeId: 'P17-034',
      nextRouteId: 'P17-035',
      subtitle: 'Stelling',
      title: 'Als ik kies voor geen behandeling, wil ik wel dat er regelmatig een scan wordt gemaakt',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ja' },
        { title: 'Nee' },
        { title: 'Weet ik niet' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/vraag-6',
      routeId: 'P17-035',
      nextRouteId: 'P17-036',
      type: 'question',
      title: 'Nu je de keuzehulp hebt gedaan: is er een keuze die je het meest aanspreekt? Zo ja, welke?',
      description: 'Heb je nog vragen aan je arts? Vul die dan ook hieronder in.',
      descriptionAlign: 'left',
      questions: [
        {
          placeholder:
            'Vul hier je antwoord in.',
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/print-overview',
      routeId: 'P17-036',
      nextRouteId: 'end',
      type: 'end',
      titleAlign: 'left',
      header: {
        subtitle: 'Einde keuzehulp',
        title: 'Alsjeblieft, hier zijn je antwoorden bij deze keuzehulp',
        description: `
          <p>Je bent nu klaar met de keuzehulp. Bespreek met je arts hoe je denkt over de mogelijkheden bij een hersen-aneurysma. En welke keuze het beste bij je past.</p>
          <p>Heb je nog vragen? Kijk dan op Thuisarts.nl bij <a href="https://www.thuisarts.nl/zwakke-plek-in-bloedvat-in-hoofd" target="_blank">Zwakke plek in een bloedvat in het hoofd.</a> Of stel ze aan je arts.</p>`,
      },
    },
  ],
}

export default hersenAneurysma
